var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading"
        }
      ],
      staticClass: "message-notice"
    },
    [
      _c(
        "div",
        { staticClass: "message-notice-top" },
        [
          _c("search-form", {
            attrs: {
              "form-data": _vm.messageFormData,
              "btn-type": "search, reset"
            },
            on: {
              changeSelect: _vm.changeSelect,
              searchForm: _vm.searchForm,
              resetForm: _vm.resetForm
            }
          })
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "message-notice-table" },
        [
          _c(
            "el-table",
            {
              ref: "multipleTable",
              staticClass: "expand-table",
              staticStyle: { width: "100%" },
              attrs: {
                border: "",
                data: _vm.messageList,
                "tooltip-effect": "dark"
              },
              on: {
                "row-click": _vm.rowClick,
                "selection-change": _vm.selectionChange
              }
            },
            [
              _c("template", { slot: "empty" }, [
                _c(
                  "div",
                  {
                    staticStyle: {
                      height: "100%",
                      width: "100%",
                      display: "flex",
                      "align-items": "center",
                      "justify-content": "center"
                    }
                  },
                  [
                    _c("no-data", {
                      attrs: { height: "400px", width: "400px" }
                    })
                  ],
                  1
                )
              ]),
              _c("el-table-column", {
                attrs: { type: "selection", width: "50" }
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "systemId",
                  label: "系统名称",
                  "min-width": "80"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c(
                          "el-tooltip",
                          {
                            staticClass: "item",
                            attrs: { effect: "dark", placement: "top" }
                          },
                          [
                            _c("div", {
                              attrs: { slot: "content" },
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.ToBreak(
                                    _vm.getsystemname(scope.row.systemId)
                                  )
                                )
                              },
                              slot: "content"
                            }),
                            _c("div", { staticClass: "line" }, [
                              _vm._v(
                                _vm._s(_vm.getsystemname(scope.row.systemId))
                              )
                            ])
                          ]
                        )
                      ]
                    }
                  }
                ])
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "messageTitle",
                  label: "消息名称",
                  "min-width": "80"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c(
                          "el-tooltip",
                          {
                            staticClass: "item",
                            attrs: { effect: "dark", placement: "top" }
                          },
                          [
                            _c("div", {
                              attrs: { slot: "content" },
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.ToBreak(scope.row.messageTitle)
                                )
                              },
                              slot: "content"
                            }),
                            _c("div", { staticClass: "line" }, [
                              _vm._v(_vm._s(scope.row.messageTitle))
                            ])
                          ]
                        )
                      ]
                    }
                  }
                ])
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "messageContent",
                  label: "消息描述",
                  "min-width": "80"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c(
                          "el-tooltip",
                          {
                            staticClass: "item",
                            attrs: { effect: "dark", placement: "top" }
                          },
                          [
                            _c("div", {
                              attrs: { slot: "content" },
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.ToBreak(scope.row.messageContent)
                                )
                              },
                              slot: "content"
                            }),
                            _c("div", { staticClass: "line" }, [
                              _vm._v(_vm._s(scope.row.messageContent))
                            ])
                          ]
                        )
                      ]
                    }
                  }
                ])
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "messageState",
                  label: "消息状态",
                  "min-width": "80"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c("div", { staticClass: "message-notice-state" }, [
                          _c("i", {
                            staticClass: "message-notice-state-circular",
                            style: {
                              background:
                                scope.row.messageState === "UNREAD"
                                  ? "#FF4E49"
                                  : "#52C41A"
                            }
                          }),
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm._f("messageStateFilter")(
                                  scope.row.messageState
                                )
                              )
                            )
                          ])
                        ])
                      ]
                    }
                  }
                ])
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "createdTime",
                  label: "发起时间",
                  "min-width": "80"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c(
                          "el-tooltip",
                          {
                            staticClass: "item",
                            attrs: { effect: "dark", placement: "top" }
                          },
                          [
                            _c("div", {
                              attrs: { slot: "content" },
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.ToBreak(scope.row.createdTime)
                                )
                              },
                              slot: "content"
                            }),
                            _c("div", { staticClass: "line" }, [
                              _vm._v(_vm._s(scope.row.createdTime))
                            ])
                          ]
                        )
                      ]
                    }
                  }
                ])
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "userIdStr",
                  label: "执行人",
                  "min-width": "80"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c(
                          "el-tooltip",
                          {
                            staticClass: "item",
                            attrs: { effect: "dark", placement: "top" }
                          },
                          [
                            _c("div", {
                              attrs: { slot: "content" },
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.ToBreak(scope.row.userIdStr)
                                )
                              },
                              slot: "content"
                            }),
                            _c("div", { staticClass: "line" }, [
                              _vm._v(_vm._s(scope.row.userIdStr))
                            ])
                          ]
                        )
                      ]
                    }
                  }
                ])
              })
            ],
            2
          )
        ],
        1
      ),
      _c("div", { staticClass: "footer-page" }, [
        _c(
          "div",
          { staticClass: "footer-left" },
          [
            _c("el-checkbox", {
              attrs: { indeterminate: _vm.isIndeterminate },
              on: { change: _vm.selectAll },
              model: {
                value: _vm.delChecked,
                callback: function($$v) {
                  _vm.delChecked = $$v
                },
                expression: "delChecked"
              }
            }),
            _c("input", {
              staticClass: "btn btn-del",
              attrs: { type: "button", value: "删除" },
              on: { click: _vm.showdeldialog }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "footer-right" },
          [
            _c("el-pagination", {
              attrs: {
                "current-page": _vm.searchReq.pageNum,
                background: "",
                layout: "total, sizes, prev, pager, next, jumper",
                total: _vm.total,
                "hide-on-single-page": false
              },
              on: {
                "size-change": _vm.onSizeChange,
                "current-change": _vm.onCurrentChange
              }
            })
          ],
          1
        )
      ]),
      _vm.showdownload
        ? _c(
            "el-dialog",
            {
              directives: [
                { name: "el-drag-dialog", rawName: "v-el-drag-dialog" }
              ],
              staticClass: "dialog_footer_btn",
              attrs: {
                "close-on-click-modal": false,
                visible: _vm.showdownload,
                width: "560",
                "custom-class": "downnotice",
                modal: false
              },
              on: {
                "update:visible": function($event) {
                  _vm.showdownload = $event
                }
              }
            },
            [
              _c("download-ifram", {
                attrs: { showdownloadurl: _vm.showdownloadurl }
              })
            ],
            1
          )
        : _vm._e(),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          staticClass: "dialog_footer_btn",
          attrs: {
            title: "查看消息",
            visible: _vm.showmessage,
            top: "5vh",
            width: "85%"
          },
          on: {
            "update:visible": function($event) {
              _vm.showmessage = $event
            }
          }
        },
        [_c("show-message", { attrs: { showmessageurl: _vm.showmessageurl } })],
        1
      ),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          staticClass: "dialog_footer_btn",
          attrs: {
            width: "382px",
            title: "删除消息",
            "close-on-click-modal": false,
            visible: _vm.ifShowDelDialog
          },
          on: {
            "update:visible": function($event) {
              _vm.ifShowDelDialog = $event
            }
          }
        },
        [
          _c("del-dialog", {
            attrs: {
              tips1: "确定要删除所选消息吗？",
              tips2: "删除消息后无法恢复，是否要删除消息"
            },
            on: {
              cancle: function($event) {
                _vm.ifShowDelDialog = false
              },
              commit: _vm.delteMessage
            }
          })
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            title: _vm.todoTitle,
            visible: _vm.showDialog,
            top: "5vh",
            width: "70%",
            center: "",
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              _vm.showDialog = $event
            }
          }
        },
        [
          _c("div", { staticClass: "task-container-body" }, [
            _vm.showDialog
              ? _c("iframe", {
                  ref: "iframe",
                  staticClass: "task-container-iframe",
                  staticStyle: {
                    width: "100%",
                    "min-height": "647px",
                    border: "none"
                  },
                  attrs: { name: "iframe", src: _vm.dialogUrl }
                })
              : _vm._e()
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }